import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import Select from '../../../Select';

export default ({ value, onChange, label }) => {
  const { statusList } = useSelector((state) => state.voiceBot);

  const statusOptions = useMemo(() => {
    return Array.isArray(statusList)
      ? statusList.map((status) => ({
          value: status.IdStatus,
          label: status.NmStatus,
        }))
      : [];
  }, [statusList]);

  const selectedOption = useMemo(() => {
    const selectedStatus = statusList?.find(
      (status) => Number(status.IdStatus) === Number(value)
    );

    return selectedStatus
      ? {
          value: selectedStatus.IdStatus,
          label: selectedStatus.NmStatus,
        }
      : null;
  }, [value, statusList]);

  const handleChange = (option) => {
    if (option) {
      onChange({ target: { value: option.value, name: 'idIvrStatus' } });
    } else {
      onChange({ target: { value: '', name: 'idIvrStatus' } });
    }
  };

  return (
    <Select
      label={label}
      options={statusOptions}
      value={selectedOption}
      onChange={(option) => handleChange(option)}
      getOptionLabel={(option) => `${option.value} - ${option.label}`}
      noOptionsMessage="Opção não encontrada"
      isClearable
      hasError={!selectedOption}
    />
  );
};
